import { Reducer } from 'redux';
import { BugReportsState, BugReportsTypes } from './types';

const INITIAL_STATE: BugReportsState = {
  bugReportData: {
    id: '',
    title: '',
    description: '',
    version: '',
    lastUpdatedBy: '',
    fixComment: '',
    fixVersion: '',
    photoUrl: '',
    status: 1,
    createdAt: '',
  },
  bugReportsList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<BugReportsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_BUG_REPORTS
    case BugReportsTypes.LIST_BUG_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bugReportsList: INITIAL_STATE.bugReportsList,
      };
    case BugReportsTypes.LIST_BUG_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bugReportsList: action.payload.bugReportsList,
        totalCount: action.payload.totalCount,
      };
    case BugReportsTypes.LIST_BUG_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bugReportsList: INITIAL_STATE.bugReportsList,
      };

    // CASES GET BUG_REPORT
    case BugReportsTypes.GET_BUG_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bugReportData: INITIAL_STATE.bugReportData,
      };
    case BugReportsTypes.GET_BUG_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bugReportData: action.payload.bugReportData,
      };
    case BugReportsTypes.GET_BUG_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bugReportData: INITIAL_STATE.bugReportData,
      };

    // CASES FILTER_BUG_REPORTS
    case BugReportsTypes.FILTER_BUG_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bugReportsList: INITIAL_STATE.bugReportsList,
      };
    case BugReportsTypes.FILTER_BUG_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bugReportsList: action.payload.bugReportsList,
        totalCount: action.payload.totalCount,
      };
    case BugReportsTypes.FILTER_BUG_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bugReportsList: INITIAL_STATE.bugReportsList,
      };

    // CASES CREATE BUG_REPORT
    case BugReportsTypes.CREATE_BUG_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bugReportData: INITIAL_STATE.bugReportData,
      };
    case BugReportsTypes.CREATE_BUG_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bugReportData: action.payload.bugReportData,
      };
    case BugReportsTypes.CREATE_BUG_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bugReportData: INITIAL_STATE.bugReportData,
      };

    // CASES UPDATE BUG_REPORT
    case BugReportsTypes.UPDATE_BUG_REPORT_REQUEST:
      return { ...state, loading: true, error: false };
    case BugReportsTypes.UPDATE_BUG_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bugReportData: action.payload.bugReportData,
      };
    case BugReportsTypes.UPDATE_BUG_REPORT_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE BUG_REPORT
    case BugReportsTypes.DELETE_BUG_REPORT_REQUEST:
      return { ...state, loading: true, error: false };
    case BugReportsTypes.DELETE_BUG_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case BugReportsTypes.DELETE_BUG_REPORT_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
